import { defineStore } from "pinia";

export const useLoaderProgressStore = defineStore("loaderProgressStore", {
  state: () => ({
    loading: false,
  }),

  actions: {
    startLoader() {
      this.loading = true;
    },
    stopLoader() {
      this.loading = false;
    },
  },
});
